import styled, { css } from 'styled-components';
import { ifNotProp, palette } from 'styled-tools';

import {
	Button,
	FontSizes,
	FontWeights,
	Text,
	TextButton,
	TextElements,
	units,
} from '@calm-web/design-system';

import Lightbulb from 'icons/lightbulb-filled.svg';

export const ButtonContainer = styled.div`
	display: flex;
	justify-content: end;
	margin-top: ${units(2)};
`;

export const ActionButton = styled(Button).attrs({
	fullWidth: true,
	backgroundColor: 'buttonBlue',
	textColor: 'white',
	fontWeight: FontWeights.Demi,
})``;

export const Title = styled(Text).attrs({
	el: TextElements.H1,
	size: FontSizes.base,
	weight: FontWeights.Demi,
})`
	color: ${palette('text')};
	margin-bottom: ${units(1.5)};
`;

export const Container = styled.div<{ hideMarginTop?: boolean; isLocationReminderDialog?: boolean }>`
	background-color: ${p =>
		p.isLocationReminderDialog ? 'transparent' : palette('cardBackgroundColor', 'white')};
	text-align: left;
	padding: ${units(1.5)};
	color: ${palette('cardContainerColor')};

	${ifNotProp(
		'hideMarginTop',
		css`
			margin-top: ${units(2)};
		`,
	)}

	${Title} {
		margin-block-start: 0;
	}
`;

export const RegularText = styled(Text).attrs({
	el: TextElements.P,
	size: FontSizes.base,
})<{ hideMarginBottom?: boolean }>`
	${ifNotProp(
		'hideMarginBottom',
		css`
			margin-bottom: ${units(3)};
		`,
	)}
`;

export const HighlightedText = styled(Text).attrs({
	el: TextElements.P,
	size: FontSizes.sm,
})`
	background-color: ${palette('cardHighlightBackgroundColor')};
	color: ${palette('adaptiveText')};
	padding: ${units(1)};
	display: flex;
	content-align: center;
`;

export const LightbulbIcon = styled(Lightbulb)`
	height: 25px;
	width: 25px;
`;

export const CardTextButton = styled(TextButton)`
	font-weight: ${FontWeights.Regular};
	color: ${palette('text')};
`;

export const ModalWrapper = styled.div`
	padding: ${units(4)};
	text-align: center;
`;
